import { EnrollmentsLookupClient } from "@app/api2/api";
import { SelectableItem, useSelectableList } from "../../Hooks/UseSelectableList";

const lookupClient = new EnrollmentsLookupClient();

export const useEnrollmentPurposeOptions = ({ defaultValue }: { defaultValue?: number }) =>
  useSelectableList<SelectableItem, number>({
    defaultId: defaultValue,
    apiCall: async () => {
      const result = await lookupClient.getEnrollmentPurposeOptions();
      return result.map((item: any) => ({
        id: item.id,
        value: item.id,
        text: item.name ?? item.text ?? String(item.id)
      }));
    },
  });

export const useSexOptions = ({ defaultValue }: { defaultValue?: number }) =>
  useSelectableList<SelectableItem, number>({
    defaultId: defaultValue,
    apiCall: async () => {
      const result = await lookupClient.getSexOptions();
      return result.map((item: any) => ({
        id: item.id,
        value: item.id,
        text: item.name ?? item.text ?? String(item.id)
      }));
    },
  });

export const useCountryOptions = (props?: { defaultValue?: number }) =>
  useSelectableList<SelectableItem, number>({
    defaultId: props?.defaultValue,
    apiCall: async () => {
      const result = await lookupClient.getCountryOptions();
      return result.map((item) => ({
        id: item.id,
        value: item.id,
        text: item.name ?? String(item.id),
        // flag: item.alpha2?.toLowerCase() as FlagNameValues,
      }));
    },
  });

export const usePhonePrefixOptions = () =>
  useSelectableList<SelectableItem, number>({
    apiCall: async () => {
      const result = await lookupClient.getCountryOptions();
      return result.filter((item) => item.phonePrefix).map((item) => ({
        id: item.id,
        value: item.id,
        text: item.phonePrefix ? `${item.name} (${item.phonePrefix})` : item.name ?? String(item.id)
      }));
    },
  });

export const useStateOptions = (props: { countryId: number, defaultValue?: number }, deps: any[] = []) =>
  useSelectableList<SelectableItem, number>({
    defaultId: props.defaultValue,
    apiCall: async () => {
      const result = await lookupClient.getStateOptions(props.countryId);
      return result.map((item) => ({
        id: item.id,
        value: item.id,
        text: item.name ?? String(item.id)
      }));
    },
    deps: [...deps, props.countryId],
    selectFirst: true
  });


export const useCityOptions = (props: { countryId: number; stateId?: number, defaultValue?: number, nameStartsWith?: string }, deps: any[] = []) =>
  useSelectableList<SelectableItem, number>({
    defaultId: props.defaultValue,
    apiCall: async () => {
      const result = await lookupClient.getCityOptions(props.countryId, props.stateId, props.nameStartsWith);
      return result.map((item) => ({
        id: item.id,
        value: item.id,
        text: item.name ?? String(item.id)
      }));
    },
    deps: [...deps, props.stateId, props.countryId, props.nameStartsWith],
  });

export const useEyeColorOptions = ({ defaultValue }: { defaultValue?: number }) =>
  useSelectableList<SelectableItem, number>({
    defaultId: defaultValue,
    apiCall: async () => {
      const result = await lookupClient.getEyeColorOptions();
      return result.map((item: any) => ({
        id: item.id,
        value: item.id,
        text: item.name ?? item.text ?? String(item.id)
      }));
    },
  });

export const useHairColorOptions = ({ defaultValue }: { defaultValue?: number }) =>
  useSelectableList<SelectableItem, number>({
    defaultId: defaultValue,
    apiCall: async () => {
      const result = await lookupClient.getHairColorOptions();
      return result.map((item: any) => ({
        id: item.id,
        value: item.id,
        text: item.name ?? item.text ?? String(item.id)
      }));
    },
  });

export const usePhoneTypeOptions = ({ defaultValue }: { defaultValue?: number }) =>
  useSelectableList<SelectableItem, number>({
    defaultId: defaultValue,
    apiCall: async () => {
      const result = await lookupClient.getPhoneTypeOptions();
      return result.map((item: any) => ({
        id: item.id,
        value: item.id,
        text: item.name ?? item.text ?? String(item.id)
      }));
    },
  });

export const useIdTypeOptions = ({defaultValue}) =>
  useSelectableList<SelectableItem, number>({
    defaultId: defaultValue,
    apiCall: async () => {
      const result = await lookupClient.getIdTypeOptions();
      return result.map((item: any) => ({
        id: item.id,
        value: item.id,
        text: item.name ?? item.text ?? String(item.id)
      }));
    },
  });

export const useFeatureTypeOptions = ({ defaultValue }: { defaultValue?: number }) =>
  useSelectableList<SelectableItem, number>({
    defaultId: defaultValue,
    apiCall: async () => {
      const result = await lookupClient.getFeatureTypeOptions();
      return result.map((item: any) => ({
        id: item.id,
        value: item.id,
        text: item.name ?? item.text ?? String(item.id)
      }));
    },
  });

export const useDnaKitOptions = () =>
  useSelectableList<SelectableItem, number>({
    apiCall: () => Promise.resolve([]),
  });

export const useEthnicityOptions = ({ defaultValue }: { defaultValue?: number }) =>
  useSelectableList<SelectableItem, number>({
    defaultId: defaultValue,
    apiCall: async () => {
      const result = await lookupClient.getEthnicityOptions();
      return result.map((item) => ({
        id: item.id,
        value: item.id,
        text: item.name ?? String(item.id)
      }));
    },
  });


export const useAddressTypeOptions = ({ defaultValue }: { defaultValue?: number }) =>
  useSelectableList<SelectableItem, number>({
    defaultId: defaultValue,
    apiCall: async () => {
      const result = await lookupClient.getAddressTypeOptions();
      return result.map((item) => ({
        id: item.id,
        value: item.id,
        text: item.name ?? String(item.id)
      }));
    },
  });

export const useCollectorOptions = (options?: { selectedId: number | string | null }) =>
  useSelectableList<SelectableItem, number>({
    defaultId: options?.selectedId ?? null as any,
    apiCall: async () => {
      const result = await lookupClient.getCollectorOptions();
      return result.map((item) => ({
        id: item.id,
        value: item.id,
        text: item.name ?? String(item.id)
      }));
    },
  });